import feather from 'feather-icons'

document.addEventListener('turbolinks:load', () => {
  feather.replace()
})

window.featherReplace = () => feather.replace()